import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const MobileApp = () => {

  // ✅ DEMO / CONCEPT PROJECTS (STRONG POSITIONING)
  const projects = [
    {
      title: "E-commerce Mobile App (Concept)",
      desc: "A modern shopping app concept with seamless checkout, cart, and product browsing experience.",
      link: "#",
    },
    {
      title: "Fitness Tracker App (UI/UX Concept)",
      desc: "Mobile app focused on tracking workouts, health metrics, and user engagement.",
      link: "#",
    },
    {
      title: "Food Delivery App (Prototype)",
      desc: "Complete mobile app flow including ordering, tracking, and payment experience.",
      link: "#",
    },
  ];

  // ✅ TESTIMONIALS (FORWARD-LOOKING / TRUST BUILDING)
  const testimonials = [
    {
      name: "Ali Raza",
      role: "Startup Founder",
      feedback:
        "Their vision for mobile apps is impressive. Looking forward to launching our product together.",
    },
    {
      name: "Sara Khan",
      role: "Entrepreneur",
      feedback:
        "The app concepts and UI ideas were very well thought out and user-friendly.",
    },
    {
      name: "Usman Ahmed",
      role: "Business Owner",
      feedback:
        "Professional approach and strong understanding of mobile product development.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-blue-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Build Powerful <span className="text-blue-400">Mobile Apps</span>
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We design and develop high-performance mobile applications focused
            on user experience, scalability, and real-world impact.
          </p>

          <p className="mt-4 text-blue-400 font-medium">
            🚀 Currently expanding in mobile app development — accepting new projects.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-blue-500 rounded-full hover:scale-105 transition">
              Start Your App
            </Link>

            <a
              href="https://calendly.com/thelogicwaves/30min"
              target="_blank"
              rel="noreferrer"
              className="px-8 py-4 border rounded-full hover:bg-white/10 transition"
            >
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 px-6 max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8">Mobile Apps That Scale</h2>

        <p className="text-gray-300 leading-relaxed mb-6">
          We focus on building mobile applications that are not only visually
          appealing but also performant, scalable, and user-friendly.
        </p>

        <p className="text-gray-400">
          From idea validation to final deployment, we help bring your app
          vision to life.
        </p>
      </section>

      {/* FEATURES */}
      <section className="py-24 px-6">
        <h2 className="text-4xl font-bold text-center mb-16">What We Offer</h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            { title: "iOS & Android Apps", desc: "Cross-platform mobile app development." },
            { title: "UI/UX Focused", desc: "Designed for seamless user experience." },
            { title: "High Performance", desc: "Optimized for speed and responsiveness." },
            { title: "Scalable Backend", desc: "Built to handle growth and traffic." },
            { title: "API Integration", desc: "Connect apps with powerful services." },
            { title: "App Store Deployment", desc: "Launch your app successfully." },
          ].map((item, i) => (
            <div key={i} className="bg-white/5 p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
              <h3 className="text-xl font-semibold mb-3 text-blue-400">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-24 px-6 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-16">Our App Development Process</h2>

        <div className="grid md:grid-cols-4 gap-10 max-w-6xl mx-auto">
          {["Idea", "Design", "Development", "Launch"].map((step, i) => (
            <div key={i}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-500 text-xl font-bold">
                {i + 1}
              </div>
              <p className="text-gray-300">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROJECTS (CONCEPT BASED) */}
      <ProjectsSection projects={projects} />

      {/* TESTIMONIALS */}
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-blue-500 to-indigo-500 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Let’s Build Your Mobile App
        </h2>

        <p className="text-gray-200 mb-8">
          Have an idea? Let’s turn it into a real product.
        </p>

        <Link to="/contact" className="bg-black px-6 py-3 rounded-full hover:scale-105 transition">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default MobileApp;